import React, { useState, useEffect } from 'react';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './authConfig';

const MsalProviderWrapper = ({ children }) => {
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    if (msalInstance) {
      msalInstance.initialize().then(() => {
        // Handle redirect promise after initialization
        msalInstance.handleRedirectPromise().then(() => {
          setIsInitialized(true);
        }).catch((err) => {
          console.error('MSAL redirect error:', err);
          setIsInitialized(true);
        });
      }).catch((err) => {
        console.error('MSAL initialization error:', err);
        setIsInitialized(true);
      });
    }
  }, []);

  // No MSAL instance (no clientId configured) - render children directly
  if (!msalInstance) {
    return <>{children}</>;
  }

  // Wait for MSAL to initialize — black screen so there's no flash before AuthGate takes over
  if (!isInitialized) {
    return <div style={{ position: 'fixed', inset: 0, background: '#1a5568' }} />;
  }

  return (
    <MsalProvider instance={msalInstance}>
      {children}
    </MsalProvider>
  );
};

export default MsalProviderWrapper;
